<template>
	<div class="service">
    <v-app id="service">
      <v-content v-if="item">
        <v-carousel hide-delimiters show-arrows-on-hover cycle height="400">
          <b v-if="getFirstImage(item.carousel_images)">
            <v-carousel-item :src="getFirstImage(item.carousel_images)">
              <mapdirection/>
              <v-card-title class="align-end fill-height white--text ml-10 main-title">
                  <b class="main-title-text">{{ item.name | uppercase }}</b>
              </v-card-title>
              <v-card-title class="align-end fill-height white--text ml-10 title">
                  <!-- <b class="title-text">{{ item.title }}</b> -->
                  <b class="title-text"><i>{{ item.carousel_text }}</i></b>
              </v-card-title>
              <v-card-title class="align-end fill-height white--text">
                <!-- Artificial Bread Crumbs -->
                  <router-link to="/">Home</router-link><v-icon>mdi-forward</v-icon>
                  <router-link :to="'/services/'+ item.Cat_slug">{{ item.Cat_slug | capitalize}}</router-link><v-icon>mdi-forward</v-icon>
                  {{  item.name | capitalize }}
                <!-- Artificial Bread Crumbs: End -->
              </v-card-title>
            </v-carousel-item>
          </b>
          <b v-if="getSecondImage(item.carousel_images)">
            <v-carousel-item :src="getSecondImage(item.carousel_images)">
              <mapdirection/>
              <v-card-title class="align-end fill-height white--text ml-10 main-title">
                  <b class="main-title-text">{{ item.name | uppercase }}</b>
              </v-card-title>
              <v-card-title class="align-end fill-height white--text ml-10 title">
                  <!-- <b class="title-text">{{ item.title }}</b> -->
                  <b class="title-text"><i>{{ item.carousel_text }}</i></b>
              </v-card-title>
              <v-card-title class="align-end fill-height white--text">
                <!-- Artificial Bread Crumbs -->
                  <router-link to="/">Home</router-link><v-icon>mdi-forward</v-icon>
                  <router-link :to="'/services/'+ item.Cat_slug">{{ item.Cat_slug | capitalize}}</router-link><v-icon>mdi-forward</v-icon>
                  {{  item.name | capitalize }}
                <!-- Artificial Bread Crumbs: End -->
              </v-card-title>
            </v-carousel-item>
          </b>
          <b v-if="getThirdImage(item.carousel_images)">
            <v-carousel-item :src="getThirdImage(item.carousel_images)">
              <mapdirection/>
              <v-card-title class="align-end fill-height white--text ml-10 main-title">
                  <b class="main-title-text">{{ item.name | uppercase }}</b>
              </v-card-title>
              <v-card-title class="align-end fill-height white--text ml-10 title">
                  <!-- <b class="title-text">{{ item.title }}</b> -->
                  <b class="title-text"><i>{{ item.carousel_text }}</i></b>
              </v-card-title>
              <v-card-title class="align-end fill-height white--text">
                <!-- Artificial Bread Crumbs -->
                  <router-link to="/">Home</router-link><v-icon>mdi-forward</v-icon>
                  <router-link :to="'/services/'+ item.Cat_slug">{{ item.Cat_slug | capitalize}}</router-link><v-icon>mdi-forward</v-icon>
                  {{  item.name | capitalize }}
                <!-- Artificial Bread Crumbs: End -->
              </v-card-title>
            </v-carousel-item>
          </b>
          <b v-if="getFourthImage(item.carousel_images)">
            <v-carousel-item :src="getFourthImage(item.carousel_images)">
              <mapdirection/>
              <v-card-title class="align-end fill-height white--text ml-10 main-title">
                  <b class="main-title-text">{{ item.name | uppercase }}</b>
              </v-card-title>
              <v-card-title class="align-end fill-height white--text ml-10 title">
                  <!-- <b class="title-text">{{ item.title }}</b> -->
                  <b class="title-text"><i>{{ item.carousel_text }}</i></b>
              </v-card-title>
              <v-card-title class="align-end fill-height white--text">
                <!-- Artificial Bread Crumbs -->
                  <router-link to="/">Home</router-link><v-icon>mdi-forward</v-icon>
                  <router-link :to="'/services/'+ item.Cat_slug">{{ item.Cat_slug | capitalize}}</router-link><v-icon>mdi-forward</v-icon>
                  {{  item.name | capitalize }}
                <!-- Artificial Bread Crumbs: End -->
              </v-card-title>
            </v-carousel-item>
          </b>
          <b v-if="getFifthImage(item.carousel_images)">
            <v-carousel-item :src="getFifthImage(item.carousel_images)">
              <mapdirection/>
              <v-card-title class="align-end fill-height white--text ml-10 main-title">
                  <b class="main-title-text">{{ item.name | uppercase }}</b>
              </v-card-title>
              <v-card-title class="align-end fill-height white--text ml-10 title">
                  <!-- <b class="title-text">{{ item.title }}</b> -->
                  <b class="title-text"><i>{{ item.carousel_text }}</i></b>
              </v-card-title>
              <v-card-title class="align-end fill-height white--text">
                <!-- Artificial Bread Crumbs -->
                  <router-link to="/">Home</router-link><v-icon>mdi-forward</v-icon>
                  <router-link :to="'/services/'+ item.Cat_slug">{{ item.Cat_slug | capitalize}}</router-link><v-icon>mdi-forward</v-icon>
                  {{  item.name | capitalize }}
                <!-- Artificial Bread Crumbs: End -->
              </v-card-title>
            </v-carousel-item>
          </b>
        </v-carousel>
        <v-tabs dark background-color="transparent">
          <v-tab><b class="label">Restaurant</b></v-tab>
          <v-tab><b class="label">Rooms</b></v-tab>
          <v-tab><b class="label">Pool</b></v-tab>
          <v-tab><b class="label">Share</b></v-tab>
          <v-tab-item>
            <v-container fluid fill-height>
              <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
              <v-card>
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Meal Name</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="dialog = false"><b>Close</b></v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <div class="container">
                  <div class="columns" style="padding-bottom: 0px; margin-bottom: 0px;">
                    <div class="column is-4">
                      <div class="columns is-multiline">
                        <div class="column is-12">
                          <img src="http://via.placeholder.com/620x620" alt="service name">
                        </div>
                        <div class="column is-4">
                          <img src="http://via.placeholder.com/620x620" alt="service name">
                        </div>
                        <div class="column is-4">
                          <img src="http://via.placeholder.com/620x620" alt="service name">
                        </div>
                        <div class="column is-4">
                          <img src="http://via.placeholder.com/620x620" alt="service name">
                        </div>
                      </div>
                    </div>
                    <div class="column is-6">
                      <div>
                        <!-- Artificial Bread Crumbs -->
                          <router-link to="/">Home</router-link><v-icon>mdi-forward</v-icon>
                          <router-link :to="'/services/'+ item.Cat_slug">{{ item.Cat_slug | capitalize}}</router-link><v-icon>mdi-forward</v-icon>
                          {{  item.name | capitalize }}
      
                        <!-- Artificial Bread Crumbs: End -->
                        <h1 class="title is-4">
                          service Name
                        </h1>
                        <p>
                          Category: service Category
                        </p>
                        <p>
                          Client: Client Name
                        </p>
                        <p>
                          Availabilty: (50) InStock
                        </p>
                        <hr>
                        <span class="tag is-rounded is-medium is-dark">
                          Out of stock
                        </span>
                        <span class="tag is-rounded is-medium">
                          <v-icon left>mdi-tag mdi-24px</v-icon> K 500
                        </span>
                      </div>
                      <div>
                        <form action="" @submit.prevent="add">
                          <div class="field">
                            <label class="label">
                              Type
                            </label>
                            <div class="control">
                              
                                <!--<div class="select is-one-third"> <select :value="selectedVariationId">
                                  <option value="">Please choose</option>
                                  <option>
                                    Variation Name

                                    <template>
                                      <v-icon left>mdi-tag mdi-24px</v-icon> K 500
                                    </template>

                                    <template>
                                      (out of stock)
                                    </template>
                                  </option>
                                </select> </div>-->
                                <!-- <v-select
                                  :items="items"
                                  label="Standard"
                                ></v-select> -->
                              
                            </div>
                          </div>

                          <div class="field has-addons">
                            <div class="control">
                              <div class="select is-fullwidth">
                                <select name="" id="">
                                  <option>
                                    Qty
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="control">
                              <button type="submit" class="button is-info">Add to cart</button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="column is-2">
                      <div class="label">Share:</div>
                      <div><img src="@/assets/googleicon.png" alt="Google" width="30" /> | <img src="@/assets/facebook.jpg" alt="Facebook" width="30" /> | <img src="@/assets/twitter.jpg" alt="Twitter" width="30" /></div>
                      <!-- <div>WhatsApp</div> -->
                    </div>
                  </div>
                  <v-tabs grow>
                    <v-tab><b class="label">Description</b></v-tab>
                    <v-tab><b class="label">Specification</b></v-tab>
                    <v-tab><b class="label">Reviews(5)</b></v-tab>
                    <v-tab><b class="label">Related services</b></v-tab>
                    <v-tab-item>
                      <b><p>Beryl Cook is one of Britain’s most talented and amusing artists .Beryl’s pictures feature women of all shapes and sizes enjoying themselves .Born between the two world wars, Beryl Cook eventually left Kendrick School in Reading at the age of 15, where she went to secretarial school and then into an insurance office. After moving to London and then Hampton, she eventually married her next door neighbour from Reading, John Cook. He was an officer in the Merchant Navy and after he left the sea in 1956, they bought a pub for a year before John took a job in Southern Rhodesia with a motor company. Beryl bought their young son a box of watercolours, and when showing him how to use it, she decided that she herself quite enjoyed painting. John subsequently bought her a child’s painting set for her birthday and it was with this that she produced her first significant work, a half-length portrait of a dark-skinned lady with a vacant expression and large drooping breasts. It was aptly named ‘Hangover’ by Beryl’s husband and still hangs in their house today</p>
                      <p>It is often frustrating to attempt to plan meals that are designed for one. Despite this fact, we are seeing more and more recipe books and Internet websites that are dedicated to the act of cooking for one. Divorce and the death of spouses or grown children leaving for college are all reasons that someone accustomed to cooking for more than one would suddenly need to learn how to adjust all the cooking practices utilized before into a streamlined plan of cooking that is more efficient for one person creating less waste. The mission</p></b>
                    </v-tab-item>
                    <v-tab-item>
                      <v-simple-table fixed-header height="300px">
                        <tbody>
                          <tr>
                            <td><i class="label">Width:</i></td>
                            <td><b class="label">128mm</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Height:</i></td>
                            <td><b class="label">508mm</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Depth:</i></td>
                            <td><b class="label">85mm</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Weight:</i></td>
                            <td><b class="label">52gm</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Quality checking:</i></td>
                            <td><b class="label">Yes</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Freshness Duration:</i></td>
                            <td><b class="label">03days</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">When packeting:</i></td>
                            <td><b class="label">Without touch of hand</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Each Box contains:</i></td>
                            <td><b class="label">60pcs</b></td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-tab-item>
                    <v-tab-item>
                      <div class="columns">
                        <div class="column is-7">
                          <p>Blake Ruiz</p>
                          <p>12th Feb, 2017 at 05:56 pm</p>
                          <p>Reply|<b>Rating (read-only)</b></p>
                          <b>Acres of Diamonds… you’ve read the famous story, or at least had it related to you. A farmer hears tales of diamonds and begins dreaming of vast riches. He sells his farm and hikes off over the horizon, never to be heard from again.</b><!--Pagination | Infinite Scroll -->
                        </div>
                        <div class="column is-5">
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-text-field v-model="name" :counter="10" :rules="nameRules" label="Your Name" required></v-text-field>
                            <v-text-field v-model="email" :rules="emailRules" label="Your E-mail" required></v-text-field>
                            <b>Place your service rating<v-rating v-model="rating" color="yellow darken-3" background-color="grey darken-1" empty-icon="$vuetify.icons.ratingFull" hover></v-rating></b>
                            <v-textarea append-icon="mdi-message-reply-text" label="Your Review" class="mx-2"></v-textarea>
                            <v-btn :disabled="!valid" color="success" class="mr-4">
                            Add Review</v-btn>
                          </v-form>
                        </div>
                      </div>
                    </v-tab-item>
                    <v-tab-item>
                      <servicecarousel />
                    </v-tab-item>
                  </v-tabs>
                </div>
              </v-card>
              <template v-slot:activator="{ on }">
              <v-layout>
                <div class="columns is-multiline">
                  <div class="column is-3">
                    <v-flex xs12>
                      <div class="label title is-3">Filters :</div>
                      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search services" single-line hide-details></v-text-field>
                      <v-select :items="cuisines" label="By Cuisines"></v-select>
                      <v-range-slider v-model="slider" label="Price" thumb-label></v-range-slider>
                      <v-switch v-model="tick" label="Show Only Special Dishes" color="indigo darken-3" value="" hide-details></v-switch>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="black--text"  v-on="on">
                          <v-card-title class="left">Price 1</v-card-title>
                        </v-img>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div style="margin-top: 0px; padding-top: 0px;"> 
                              <v-card-title>Meal 1 | <add-to-cart /></v-card-title>
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="black--text"  v-on="on">
                          <v-card-title class="left">Price 1</v-card-title>
                        </v-img>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div style="margin-top: 0px; padding-top: 0px;"> 
                              <v-card-title>Meal 1 | <add-to-cart /></v-card-title>
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="black--text"  v-on="on">
                          <v-card-title class="left">Price 1</v-card-title>
                        </v-img>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div style="margin-top: 0px; padding-top: 0px;"> 
                              <v-card-title>Meal 1 | <add-to-cart /></v-card-title>
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="black--text"  v-on="on">
                          <v-card-title class="left">Price 1</v-card-title>
                        </v-img>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div style="margin-top: 0px; padding-top: 0px;"> 
                              <v-card-title>Meal 1 | <add-to-cart /></v-card-title>
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                </div>
              </v-layout>
            </template>
            </v-dialog>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-simple-table fixed-header height="300px">
              <tbody>
                <tr>
                  <td><i class="label">Width:</i></td>
                  <td><b class="label">128mm</b></td>
                </tr>
                <tr>
                  <td><i class="label">Height:</i></td>
                  <td><b class="label">508mm</b></td>
                </tr>
                <tr>
                  <td><i class="label">Depth:</i></td>
                  <td><b class="label">85mm</b></td>
                </tr>
                <tr>
                  <td><i class="label">Weight:</i></td>
                  <td><b class="label">52gm</b></td>
                </tr>
                <tr>
                  <td><i class="label">Quality checking:</i></td>
                  <td><b class="label">Yes</b></td>
                </tr>
                <tr>
                  <td><i class="label">Freshness Duration:</i></td>
                  <td><b class="label">03days</b></td>
                </tr>
                <tr>
                  <td><i class="label">When packeting:</i></td>
                  <td><b class="label">Without touch of hand</b></td>
                </tr>
                <tr>
                  <td><i class="label">Each Box contains:</i></td>
                  <td><b class="label">60pcs</b></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-tab-item>
          <v-tab-item>
            <div class="columns">
              <div class="column is-7">
                <p>Blake Ruiz</p>
                <p>12th Feb, 2017 at 05:56 pm</p>
                <p>Reply|<b>Rating (read-only)</b></p>
                <b>Acres of Diamonds… you’ve read the famous story, or at least had it related to you. A farmer hears tales of diamonds and begins dreaming of vast riches. He sells his farm and hikes off over the horizon, never to be heard from again.</b><!--Pagination | Infinite Scroll -->
              </div>
              <div class="column is-5">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field v-model="name" :counter="10" :rules="nameRules" label="Your Name" required></v-text-field>
                  <v-text-field v-model="email" :rules="emailRules" label="Your E-mail" required></v-text-field>
                  <b>Place your service rating<v-rating v-model="rating" color="yellow darken-3" background-color="grey darken-1" empty-icon="$vuetify.icons.ratingFull" hover></v-rating></b>
                  <v-textarea append-icon="mdi-message-reply-text" label="Your Review" class="mx-2"></v-textarea>
                  <v-btn :disabled="!valid" color="success" class="mr-4">
                  Add Review</v-btn>
                </v-form>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="container">
              <social-sharing url="https://convergeo-de7b6.firebaseapp.com" :title="item.name" :description="item.description" :quote="'This product is can be found in ' + item.client" hashtags="convergeo,ecommerce,product" twitter-user="Convergeo" inline-template>
                <div>
                  <network network="facebook">
                    <a href="#"><img src="@/assets/facebook.jpg" alt="Facebook" width="50" /></a>
                  </network> <v-divider class="mx-4" vertical></v-divider>
                  <network network="linkedin">
                    <a href="#"><img src="@/assets/linkedIn.png" alt="linkedin" width="50" /></a>
                  </network> <v-divider class="mx-4" vertical></v-divider>
                  <network network="pinterest">
                    <a href="#"><img src="@/assets/pinterest.jpg" alt="pinterest" width="50" /></a>
                  </network> <v-divider class="mx-4" vertical></v-divider>
                  <network network="skype">
                    <a href="#"><img src="@/assets/skype.jpg" alt="skype" width="50" /></a>
                  </network> <v-divider class="mx-4" vertical></v-divider>
                  <!-- <network network="sms">
                    <i class="fa fa-commenting-o"></i> SMS
                  </network> -->
                  <network network="twitter">
                    <a href="#"><img src="@/assets/twitter.jpg" alt="Twitter" width="50" /></a>
                  </network> <v-divider class="mx-4" vertical></v-divider>
                  <network network="whatsapp">
                    <a href="#"><img src="@/assets/whatsapp.jpg" alt="whatsapp" width="50" /></a>
                  </network> 
                </div>
              </social-sharing>
            </div>
          </v-tab-item>
        </v-tabs>
      </v-content>
    </v-app>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {db} from '@/firebase'
  import SocialSharing from 'vue-social-sharing'
  Vue.use(SocialSharing)
  import mapdirection from '@/components/Client/map.vue'

	export default {
    name: 'service',
    data: () => ({
      item: null,
      dialog: false,
      cuisines : [
        'All',
        'Indian',
        'Chinese',
        'African',
        'Italian',
        'Indian'
      ],
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          to: '/'
        },
        {
          text: 'Service Category',
          disabled: false,
          to: '/s/categories/:slug'
        },
        {
          text: 'Service Page',
          disabled: true
        },
      ],
      slider: [30, 60]
    }),
    methods: {
      getFirstImage(carousel_images){
        return carousel_images[0]
      },
      getSecondImage(carousel_images){
        return carousel_images[1]
      },
      getThirdImage(carousel_images){
        return carousel_images[2]
      },
      getFourthImage(carousel_images){
        return carousel_images[3]
      },
      getFifthImage(carousel_images){
        return carousel_images[4]
      }
    },
    components: {
      mapdirection
    },
    created(){
      //get item data 
      let ref = db.collection('services').where('slug', '==', this.$route.params.slug)
        ref.get().then(snapshot => {
            snapshot.forEach(doc => {
                //console.log(doc.data());
                this.item = doc.data()
                this.item.id = doc.id
            })
            /* eslint-disable */
            console.log(this.item);
            /* eslint-enable */
        })
    }
  }
</script>

<style scoped>
  .map {
    position: absolute;
    bottom: 300px;
    left: 80%;
  }
  .main-title {
    position: absolute;
    bottom: 110px;
  }
  .title {
    position: absolute;
    bottom: 40px;
  }
  .main-title-text {
    font-size: 30px;
  }
  .title-text {
    font-size: 25px;
    color: purple;
  }
  .left {
    float: right;
  }
</style>
